import axios from "axios";

export const getUsers = async ({ query = {}, controller = null, excludeInterceptor = false }: any) => {	
	const params: any = {params : query, excludeInterceptor}
	if(controller?.signal){
		params.signal = controller.signal
	}

	try {
		const res: any = await axios.get(`/clients/users`, params);
		return res?.data ? res.data : [];
	} catch (e: any) {
		return [];
	}
};

export const getUser = async ({ data, controller = null}: any) => {	
	try {
		const res: any = await axios.get(`/clients/users/${data.id}`);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const createUser = async ({ create }: any) => {
	try {
		const res: any = await axios.post(`/clients/users/`, create);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};


export const updateUser = async ({ data, update }: any) => {
	try {
		const res: any = await axios.put(`/clients/users/${data.id}`, update);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};


export const deleteUser = async ({ data }: any) => {
	try {
		const res: any = await axios.delete(`/clients/users/${data.id}`);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const resendInvite = async ({ data }: any) => {
	try {
		const res: any = await axios.post(`/clients/${data.id}/resend-invite`);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};
